import styled from 'styled-components';

export const Box = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px 20px;
    background-color: ${({ theme }) => theme.palette.primary.background};
    border-radius: 0 0 21px 21px;
  }
`;
